import styled from "@emotion/styled";
import { ToggleButton } from "@mui/material";

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    "&.Mui-selected, &.Mui-selected:hover": {
        backgroundColor: 'rgba(105, 168, 166, 0.4)'
    }
}));

export default StyledToggleButton;